import React, { useEffect, useRef, useState } from "react";
import "./FilterSection.css";
import { showErrorToast } from "../../assets/toastUtils";
import styles from "./NewFilterHotels.module.scss";
import { FilterIcon } from "../../utils/svgIcons";

function NewFilterHotels({ sendDataToParent }) {
  const handleReset = () => {
    setSelectedBudget("");
    setMinMax({
      min: "",
      max: "",
    });

    setStarsArray([]);
  };

  const [isOpenBudget, setIsOpenBudget] = useState(false);
  const [isOpenCategory, setIsOpenCategory] = useState(false);
  const [isOpenDestination, setIsOpenDestination] = useState(false);
  const [isOpenThemes, setIsOpenThemes] = useState(false);
  const toggleAccordionBudget = () => {
    setIsOpenBudget(!isOpenBudget);
  };
  const toggleAccordionCategory = () => {
    setIsOpenCategory(!isOpenCategory);
  };
  const toggleAccordionDestination = () => {
    setIsOpenDestination(!isOpenDestination);
  };
  const toggleAccordionThemes = () => {
    setIsOpenThemes(!isOpenThemes);
  };

  // sam work start

  const [budgetArray, setBudgetArray] = useState([]);
  const [selectedBudget, setSelectedBudget] = useState("");
  const [starsArray, setStarsArray] = useState([]);
  const [destinationArray, setDestinationArray] = useState([]);
  const [durationArray, setDurationArray] = useState([]);
  const [noOfNights, setNoOfNights] = useState("");

  const [minMax, setMinMax] = useState({
    min: "",
    max: "",
  });

  const handleBudgetChange = (value) => {
    setMinMax((prevMinMax) => ({
      min: "",
      max: "",
    }));
    setSelectedBudget(value);
  };

  const handleBudgetChangeMinMax = (value) => {
    // setSelectedBudget(value);
    // console.log(value, "value");
    const { min, max } = value;
    if (Number(min) > Number(max)) {
      showErrorToast("Please Enter Valid Budget Range");
      return;
    }
    setSelectedBudget(`${min}-${max}`);
  };

  const handleStarsCheckboxChange = (category) => {
    setStarsArray((prevArray) => {
      if (prevArray.includes(category)) {
        return prevArray.filter((item) => item !== category);
      } else {
        return [...prevArray, category];
      }
    });
  };

  useEffect(() => {
    const data = {
      budget: selectedBudget,
      stars: starsArray,
    };

    sendDataToParent(data);
  }, [selectedBudget, starsArray]);

  const [modifyPkg, setModiyPkg] = useState(false);
  const [mobileHead, setMobileHead] = useState(false);
  const toggleModify = () => {
    setModiyPkg(!modifyPkg);
  };

  const closePopup = () => {
    setModiyPkg(false);
  };

  useEffect(() => {
    if (window.innerWidth <= 768) {
      setMobileHead(true);
    } else {
      setMobileHead(false);
    }
  }, []);

  const sendingData = {
    budget: selectedBudget,
    duration: durationArray,
    destinations: destinationArray,
    noOfNights: noOfNights,
  };

  const overlayRef = useRef(null);

  const handleClickOutsideClosePopup = (e) => {
    if (
      window.innerWidth > 768 &&
      overlayRef.current &&
      !overlayRef.current.contains(e.target)
    ) {
      setIsOpenDestination(false);
      setIsOpenBudget(false);
      setIsOpenCategory(false);
      // setIsOpenDuration(false);
      // setThemeOpen(false);
    }

  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutsideClosePopup);
    return () => {
      document.removeEventListener("mousedown", handleClickOutsideClosePopup);
    };
  }, []);

  useEffect(() => {

    if (window.innerWidth < 768) {
      setIsOpenBudget(true);
      setIsOpenDestination(true);
      // setIsOpenDuration(true);
      setIsOpenThemes(true);
      setIsOpenCategory(true);
    }
  }, []);

  return (
    <>
      <div ref={overlayRef} className={styles.filters_mobile_wrapper}>
        <div className={styles.filters_mobile_parent}>
          <div className={styles.filters_mobile_parent}>
            <button onClick={toggleModify}>
              <FilterIcon />
              Filters
            </button>
          </div>
        </div>
        {modifyPkg && (
          <div className="filters p_0" id="mobileFilters">
            <div className="p_20">
              <svg
                onClick={closePopup}
                width="14"
                height="13"
                viewBox="0 0 14 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M1 12.5L13 0.5" stroke="#AAAAAA" strokeWidth="1.2" />
                <path d="M13 12.5L1 0.5" stroke="#AAAAAA" strokeWidth="1.2" />
              </svg>
            </div>
            <div className="agent border-bottom-one">
              <h4>Filter</h4>
              <div className="buttons m_0">
                <button
                  className="primary_btn"
                  onClick={handleReset}
                  style={{ width: "50px", backgroundColor: "#016937" }}
                >
                  Reset
                </button>
              </div>
            </div>

            {/* Budget Filter */}
            <div className="filter_checkbox border-bottom-one">
              <h6
                className="flex_align_center justify_content_between"
                onClick={toggleAccordionBudget}
                style={{ cursor: "pointer" }}
              >
                <b>
                  Budget <small>(Rate/Night)</small>
                </b>
                <svg
                  width="10"
                  height="8"
                  viewBox="0 0 13 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{
                    transition: "transform 0.5s",
                  transform: isOpenBudget ? "rotate(180deg)" : "rotate(0deg)",
                  }}
                >
                  <path
                    d="M11.5527 1.34473L5.86308 6.65507L0.552735 1.34473"
                    stroke="#222222"
                    strokeWidth="1.5"
                  />
                </svg>
              </h6>
              {isOpenBudget && (
                <div>
                  <div className="flex pt_10">
                    <input
                      type="radio"
                      checked={"0-8000" === selectedBudget}
                      value={"0-8000"}
                      onChange={(e) => handleBudgetChange(e.target.value)}
                      id="0-8000"
                    />
                    <label htmlFor="0-8000">0 to ₹8,000</label>
                  </div>
                  <div className="flex pt_10">
                    <input
                      type="radio"
                      value={"8000-20000"}
                      checked={"8000-20000" === selectedBudget}
                      onChange={(e) => handleBudgetChange(e.target.value)}
                      id="8000-20000"
                    />
                    <label htmlFor="8000-20000">₹8,000 to ₹20,000</label>
                  </div>
                  <div className="flex pt_10">
                    <input
                      type="radio"
                      value={"20000-35000"}
                      checked={"20000-35000" === selectedBudget}
                      onChange={(e) => handleBudgetChange(e.target.value)}
                      id="20000-35000"
                    />
                    <label htmlFor="20000-35000">₹20,000 to ₹35,000</label>
                  </div>
                  <div className="flex pt_10">
                    <input
                      type="radio"
                      value={"35000-50000"}
                      checked={"35000-50000" === selectedBudget}
                      onChange={(e) => handleBudgetChange(e.target.value)}
                      id="35000-50000"
                    />
                    <label htmlFor="35000-50000">₹35,000 to 50,000</label>
                  </div>

                  {/* <div>
                      <strong style={{ marginTop: "10px", display: "block" }}>
                        Your Budget
                      </strong>
                      <div className="filter_your_budget_parent">
                        <span className="filter_your_budget">
                          <input
                            // disabled={selectedBudget ? true : false}
                            type="number"
                            placeholder="Min"
                            id="min"
                            name="min"
                            value={minMax.min}
                            onChange={(e) => {
                              setSelectedBudget("");
                              setMinMax({ ...minMax, min: e.target.value });
                            }}
                          />
                        </span>
                        <span>to</span>

                        <span className="filter_your_budget">
                          <input
                            // disabled={selectedBudget ? true : false}
                            type="number"
                            placeholder="Max"
                            id="max"
                            name="max"
                            value={minMax.max}
                            onChange={(e) => {
                              setSelectedBudget("");
                              setMinMax({ ...minMax, max: e.target.value });
                            }}
                          />
                        </span>

                        <button
                          onClick={() => handleBudgetChangeMinMax(minMax)}
                          className="icon_btn"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            fill="#fff"
                          >
                            <path d="M7.293 4.707 14.586 12l-7.293 7.293 1.414 1.414L17.414 12 8.707 3.293 7.293 4.707z" />
                          </svg>
                        </button>
                      </div>
                    </div> */}
                </div>
              )}
            </div>

            {/* Hotel Category Filter */}
            <div className="filter_checkbox ">
              <h6
                className="flex_align_center justify_content_between"
                onClick={() => setIsOpenCategory((prev) => !prev)}
                style={{ cursor: "pointer" }}
              >
                <b>Star Rating</b>
                <svg
                  width="10"
                  height="8"
                  viewBox="0 0 13 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{
                    transition: "transform 0.5s",
                    transform: isOpenCategory ? "rotate(180deg)" : "rotate(0deg)",
                  }}
                >
                  <path
                    d="M11.5527 1.34473L5.86308 6.65507L0.552735 1.34473"
                    stroke="#222222"
                    strokeWidth="1.5"
                  />
                </svg>
              </h6>
              {isOpenCategory && (
                <div>
                  <div className="flex pt_10 flex_gap_5 align_items_center">
                    <input
                      type="checkbox"
                      value={"1"}
                      checked={starsArray.includes("1")}
                      onChange={() => handleStarsCheckboxChange("1")}
                      id="1"
                    />
                    <label htmlFor="1">1 Star</label>
                  </div>
                  <div className="flex pt_10 flex_gap_5 align_items_center">
                    <input
                      type="checkbox"
                      checked={starsArray.includes("2")}
                      onChange={() => handleStarsCheckboxChange("2")}
                      id="2"
                    />
                    <label htmlFor="2">2 Star</label>
                  </div>
                  <div className="flex pt_10 flex_gap_5 align_items_center">
                    <input
                      type="checkbox"
                      checked={starsArray.includes("3")}
                      onChange={() => handleStarsCheckboxChange("3")}
                      id="3"
                    />
                    <label htmlFor="3">3 Star</label>
                  </div>
                  <div className="flex pt_10 flex_gap_5 align_items_center">
                    <input
                      type="checkbox"
                      checked={starsArray.includes("4")}
                      onChange={() => handleStarsCheckboxChange("4")}
                      id="4"
                    />
                    <label htmlFor="4">4 Star</label>
                  </div>
                  <div className="flex pt_10 flex_gap_5 align_items_center">
                    <input
                      type="checkbox"
                      checked={starsArray.includes("5")}
                      onChange={() => handleStarsCheckboxChange("5")}
                      id="5"
                    />
                    <label htmlFor="5"> 5 Star</label>
                  </div>
                </div>
              )}
            </div>

            <div className="apply_btn">
              <button
                onClick={() => {
                  sendDataToParent(sendingData);
                  setModiyPkg(false);
                }}
                className="primary_btn"
                style={{ backgroundColor: "#016937" }}
              >
                <h4>Apply Now</h4>
              </button>
            </div>
          </div>
        )}
      </div>

      <div className={styles.filters_wrapper}>
        <div ref={overlayRef}  className={styles.filters}>
          {/* Budget Filter */}
          <div className={styles.filter_div} id="overlay">
            <div
              className={styles.filter_heading_parent}
              onClick={toggleAccordionBudget}
            >
              <div className={styles.filter_heading}>
                {" "}
                Budget <small>(Rate/Night)</small>
              </div>
              <svg
                width="10"
                height="8"
                viewBox="0 0 13 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{
                  transition: "transform 0.5s",
                  transform: isOpenBudget ? "rotate(180deg)" : "rotate(0deg)",
                }}
              >
                <path
                  d="M11.5527 1.34473L5.86308 6.65507L0.552735 1.34473"
                  stroke="#222222"
                  strokeWidth="1.5"
                />
              </svg>
            </div>

            {isOpenBudget && (
              <div className={styles.filter_content}>
                <div
                  className={styles.clear_all}
                  onClick={() => setSelectedBudget(null)}
                >
                  Clear All
                </div>
                <div className="flex pt_10">
                  <input
                    type="radio"
                    checked={"0-8000" === selectedBudget}
                    value={"0-8000"}
                    onChange={(e) => handleBudgetChange(e.target.value)}
                    id="0-8000"
                  />
                  <label htmlFor="0-8000">0 to ₹8,000</label>
                </div>
                <div className="flex pt_10">
                  <input
                    type="radio"
                    value={"8000-20000"}
                    checked={"8000-20000" === selectedBudget}
                    onChange={(e) => handleBudgetChange(e.target.value)}
                    id="8000-20000"
                  />
                  <label htmlFor="8000-20000">₹8,000 to ₹20,000</label>
                </div>
                <div className="flex pt_10">
                  <input
                    type="radio"
                    value={"20000-35000"}
                    checked={"20000-35000" === selectedBudget}
                    onChange={(e) => handleBudgetChange(e.target.value)}
                    id="20000-35000"
                  />
                  <label htmlFor="20000-35000">₹20,000 to ₹35,000</label>
                </div>
                <div className="flex pt_10">
                  <input
                    type="radio"
                    value={"35000-50000"}
                    checked={"35000-50000" === selectedBudget}
                    onChange={(e) => handleBudgetChange(e.target.value)}
                    id="35000-50000"
                  />
                  <label htmlFor="35000-50000">₹35,000 to 50,000</label>
                </div>

                {/* <div>
                  <strong style={{ marginTop: "10px", display: "block" }}>
                    Your Budget
                  </strong>
                  <div className="filter_your_budget_parent">
                    <span className="filter_your_budget">
                      <input
                        // disabled={selectedBudget ? true : false}
                        type="number"
                        placeholder="Min"
                        id="min"
                        name="min"
                        value={minMax.min}
                        onChange={(e) => {
                          setSelectedBudget("");
                          setMinMax({ ...minMax, min: e.target.value });
                        }}
                      />
                    </span>
                    <span>to</span>

                    <span className="filter_your_budget">
                      <input
                        // disabled={selectedBudget ? true : false}
                        type="number"
                        placeholder="Max"
                        id="max"
                        name="max"
                        value={minMax.max}
                        onChange={(e) => {
                          setSelectedBudget("");
                          setMinMax({ ...minMax, max: e.target.value });
                        }}
                      />
                    </span>

                    <button
                      onClick={() => handleBudgetChangeMinMax(minMax)}
                      className="icon_btn"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        fill="#fff"
                      >
                        <path d="M7.293 4.707 14.586 12l-7.293 7.293 1.414 1.414L17.414 12 8.707 3.293 7.293 4.707z" />
                      </svg>
                    </button>
                  </div>
                 
                </div> */}
              </div>
            )}
          </div>

          {/* Hotel Category Filter */}
          <div className={styles.filter_div} id="overlay">
            <div
              className={styles.filter_heading_parent}
              onClick={() => setIsOpenCategory((prev) => !prev)}
            >
              <div className={styles.filter_heading}>Star Rating</div>
              <svg
                width="10"
                height="8"
                viewBox="0 0 13 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{
                  transition: "transform 0.5s",
                  transform: isOpenCategory ? "rotate(180deg)" : "rotate(0deg)",
                }}
              >
                <path
                  d="M11.5527 1.34473L5.86308 6.65507L0.552735 1.34473"
                  stroke="#222222"
                  strokeWidth="1.5"
                />
              </svg>
            </div>
            {isOpenCategory && (
              <div className={styles.filter_content}>
                <div
                  className={styles.clear_all}
                  onClick={() => setStarsArray([])}
                >
                  Clear All
                </div>
                <div className="flex pt_10 flex_gap_5 align_items_center">
                  <input
                    type="checkbox"
                    value={"1"}
                    checked={starsArray.includes("1")}
                    onChange={() => handleStarsCheckboxChange("1")}
                    id="1"
                  />
                  <label htmlFor="1">1 Star</label>
                </div>
                <div className="flex pt_10 flex_gap_5 align_items_center">
                  <input
                    type="checkbox"
                    checked={starsArray.includes("2")}
                    onChange={() => handleStarsCheckboxChange("2")}
                    id="2"
                  />
                  <label htmlFor="2">2 Star</label>
                </div>
                <div className="flex pt_10 flex_gap_5 align_items_center">
                  <input
                    type="checkbox"
                    checked={starsArray.includes("3")}
                    onChange={() => handleStarsCheckboxChange("3")}
                    id="3"
                  />
                  <label htmlFor="3">3 Star</label>
                </div>
                <div className="flex pt_10 flex_gap_5 align_items_center">
                  <input
                    type="checkbox"
                    checked={starsArray.includes("4")}
                    onChange={() => handleStarsCheckboxChange("4")}
                    id="4"
                  />
                  <label htmlFor="4">4 Star</label>
                </div>
                <div className="flex pt_10 flex_gap_5 align_items_center">
                  <input
                    type="checkbox"
                    checked={starsArray.includes("5")}
                    onChange={() => handleStarsCheckboxChange("5")}
                    id="5"
                  />
                  <label htmlFor="5"> 5 Star</label>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
export default NewFilterHotels;
